require('./join-zoom-meeting-cta-template.html');

angular.module('bbl.directives.join-zoom')
  .directive('joinZoomMeetingCta', [function joinZoomMeetingCtaDirective() {
    return {
      restrict: 'EA',
      templateUrl: 'join-zoom-meeting-cta-template.html',
      scope: {
        bridge: '@',
      },
      controller: ['$scope', '$intercom', joinZoomMeetingCtaCtrl],
      link: function($scope, $el) {}
    };
  }]);

function joinZoomMeetingCtaCtrl($scope, $intercom) {
  $scope.d = {modal: false};
  $scope.showModal = function() {
    $scope.d.modal = true;

    $intercom.trackEvent('join zoom cta');
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/join-zoom/join-zoom-meeting-cta/index.js
 ** module id = 335
 ** module chunks = 0
 **/